import { render, staticRenderFns } from "./ConnectDBModal.vue?vue&type=template&id=11828586&scoped=true&"
import script from "./ConnectDBModal.vue?vue&type=script&lang=js&"
export * from "./ConnectDBModal.vue?vue&type=script&lang=js&"
import style0 from "./ConnectDBModal.vue?vue&type=style&index=0&id=11828586&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11828586",
  null
  
)

export default component.exports